import { MESSAGE_TYPE } from "./enums.js";
import useUserStore from '../store/userStore.js';
import i18n from '@/i18n';

const LEGACY_TIP_RULES = [
    { pattern: /^(.+)解散了群聊$/, key: 'tip.group.disband' },
    { pattern: /^(.+)退出了群聊$/, key: 'tip.group.quit' },
    { pattern: /^(.+)将(.+)移出了群聊$/, key: 'tip.group.remove' },
    { pattern: /^(.+)邀请(.+)加入了群聊$/, key: 'tip.group.invite' },
    { pattern: /^(.+)通过(.+)分享的名片加入了群聊$/, key: 'tip.group.joinByCard' },
    { pattern: /^(.+)通过(.+)分享的二维码加入了群聊$/, key: 'tip.group.joinByQr' },
    { pattern: /^(.+)置顶了一条消息$/, key: 'tip.group.topMessage' },
    { pattern: /^(.+)开启了全员禁言,只有群主和管理员可以发言$/, key: 'tip.group.mutedAll' },
    { pattern: /^(.+)解除了全员禁言$/, key: 'tip.group.unmutedAll' },
    { pattern: /^(.+)开启了(.+)的禁言$/, key: 'tip.group.memberMuted' },
    { pattern: /^(.+)解除了(.+)的禁言$/, key: 'tip.group.memberUnmuted' },
    { pattern: /^(.+)成为本群管理员$/, key: 'tip.group.addManager' },
    { pattern: /^(.+)被移除管理员身份$/, key: 'tip.group.removeManager' },
    { pattern: /^(.+)发起了通话$/, key: 'tip.group.rtcStart' },
    { pattern: /^通话结束$/, key: 'tip.group.rtcEnd' },
    { pattern: /^你们已成为好友，现在可以开始聊天了$/, key: 'tip.friend.becameFriend' },
    { pattern: /^你们的好友关系已解除$/, key: 'tip.friend.relationRemoved' },
];
const LEGACY_MESSAGE_KEYS = {
    'IM通知开通': 'home.imNotifyEnabled',
};

function previewContent(m) {
    let content = i18n.t('chat.unsupportedType');
    try {
        if (m.type == MESSAGE_TYPE.IMAGE) {
            content = i18n.t('chat.previewImage');
        } else if (m.type == MESSAGE_TYPE.VIDEO) {
            content = i18n.t('chat.previewVideo');
        } else if (m.type == MESSAGE_TYPE.FILE) {
            content = i18n.t('chat.previewFile') + ' ' + JSON.parse(m.content).name;
        } else if (m.type == MESSAGE_TYPE.AUDIO) {
            content = i18n.t('chat.previewVoice') + ' ' + JSON.parse(m.content).duration + '"';
        } else if (m.type == MESSAGE_TYPE.USER_CARD) {
            content = i18n.t('chat.previewUserCard') + ' ' + JSON.parse(m.content).nickName;
        } else if (m.type == MESSAGE_TYPE.GROUP_CARD) {
            content = i18n.t('chat.previewGroupCard') + ' ' + JSON.parse(m.content).groupName;
        } else if (m.type == MESSAGE_TYPE.STICKER) {
            content = i18n.t('chat.previewSticker') + ' ' + JSON.parse(m.content).name;
        } else if (m.type == MESSAGE_TYPE.MERGE_FORWARD) {
            const n = JSON.parse(m.content).messages.length;
            content = i18n.t('chat.mergeForwardCount', { n });
        } else if (m.type == MESSAGE_TYPE.ACT_RT_VOICE) {
            content = i18n.t('chat.voiceCallTag');
        } else if (m.type == MESSAGE_TYPE.ACT_RT_VIDEO) {
            content = i18n.t('chat.videoCallTag');
        } else if (m.type == MESSAGE_TYPE.SYSTEM_MESSAGE) {
            content = m.title;
        } else if (m.type == MESSAGE_TYPE.TEXT || m.type == MESSAGE_TYPE.RECALL) {
            content = m.content;
        } else if (m.type == MESSAGE_TYPE.TIP_TEXT) {
            content = displayContent(m.content);
            const userStore = useUserStore();
            content = content.replace(/#\{([^:]+):(\d+)\}/g, (match, displayName, userId) => {
                if (userStore.userInfo.id == userId) {
                    return i18n.t('chat.you');
                }
                return displayName;
            });
        }
    } catch (e) {
        console.log("message:", m, e);
    }
    return content;
}

/**
 * TIP_TEXT 展示文案：若 content 为 key+params JSON 则按当前语言渲染，否则返回原 content（历史纯字符串）
 * @param {string} content - 存库的 content
 * @returns {string} 展示用文案
 */
function displayContent(content) {
    try {
         // 兼容旧版本
        if (typeof content !== 'string' || !content.trim().startsWith('{')) {
            return localizeLegacyTip(content);
        }
        // 转化
        const obj = JSON.parse(content);
        if (obj && obj.key) {
            return i18n.t(obj.key, obj.params) || content;
        }
    } catch (e) {
        console.log("displayContent error,message:", content, e);
    }
    return localizeLegacyTip(content);
}

function localizeLegacyTip(content) {
    if (typeof content !== 'string') return content;
    if (LEGACY_MESSAGE_KEYS[content]) return i18n.t(LEGACY_MESSAGE_KEYS[content]);

    for (const { pattern, key } of LEGACY_TIP_RULES) {
        const match = content.match(pattern);
        if (match) return i18n.t(key, match.slice(1).map(normalizeLegacyTipParam));
    }
    return content;
}

function normalizeLegacyTipParam(value) {
    return value === '你' ? i18n.t('chat.you') : value;
}

export {
    previewContent,
    displayContent
};
